module.exports = __webpack_public_path__ + "img/home-service.cc578e41.svg";